import { Backdrop, Button, InputAdornment, TextField } from "@mui/material";
import React, { FunctionComponent, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { listRetailerMasterStart } from "../../redux/retail-master/listRetailerMaster";
import { useSelector } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/Hooks";
import { useSearchParams } from "react-router-dom";
import { IDistributorMaster } from "./IDistributorMaster";
import DistributorMasterList from "./DistributorMasterList";
import { clearCreateDistributorMaster } from "../../redux/distributor-master/createDistributorMaster";
import { clearEditDistributorMaster } from "../../redux/distributor-master/editDistributorMaster";
import { raise_api_call_list_general_setting } from "../../redux/general-setting/list-general-setting-reducer";
import { listDistributorMasterStart } from "../../redux/distributor-master/listDistributorMaster";
import { useCommonContext } from "../../Utils/commonContext";
import SearchImg from "../../assets/images/search.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";

const statusItems = [
  {
    className: "approve_sts",
    label: true,
  },
  { className: "reject_sts", label: false },
];

const DistributorMaster: FunctionComponent = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [distributor, setDistributor] = useState<IDistributorMaster>({});
  const [search, setSearch] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const { data: distributorList, isLoading: listDistributorLoading } =
    useAppSelector((state) => state.ListDistributorMaster);
  const { isLoading: createReatilerLoading, data: createDistributor } =
    useAppSelector((state) => state.CreateDistributorMaster);

  const { isLoading: editdistributorLoading, data: editDistributor } =
    useAppSelector((state) => state.EditDistributorMaster);
  const ListDistributor =
    distributorList?.result?.map((distributor, index) => ({
      ...distributor,
      index: index + 1,
    })) ?? [];
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();

  // list render
  useEffect(() => {
    dispatch(listDistributorMasterStart(null));
  }, [createDistributor, editDistributor]);

  //clear create edit data and get the state list
  useEffect(() => {
    dispatch(raise_api_call_list_general_setting(""));
    return () => {
      dispatch(clearCreateDistributorMaster());
      dispatch(clearEditDistributorMaster());
    };
  }, []);

  useEffect(() => {
    if (ListDistributor?.length !== 0) {
      const distributorCheckById =
        searchParams.get("id") &&
        ListDistributor?.find(
          (distributor) => distributor.id === Number(searchParams.get("id"))
        );

      if (distributorCheckById) {
        setDistributor(distributorCheckById);
      } else {
        setDistributor({});
      }
    }
  }, [
    searchParams.get("id"),
    ListDistributor?.length,
    createDistributor,
    editDistributor,
  ]);

  const statusClassName = (value: boolean) => {
    return statusItems.find((it) => value === it.label)?.className;
  };

  const handleBack = () => {
    setDistributor({});
    setShowBack(false);
    setTitleContext("Distributor Master");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (distributor?.name) {
      setShowBack(true);
    }
  }, [distributor]);

  useEffect(() => {
    setTitleContext(distributor.name ?? "Distributor Master");
  }, [distributor]);

  return (
    <div className="partner-details">
      <div className={`content_container`}>
        <div
          className={`mini_side_container`}
          style={{
            display: isMobile && distributor.id ? "none" : "initial",
          }}
        >
          <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
            Distributor Master
          </h5>
          <div className="side_search_container">
            <TextField
              autoComplete="off"
              autoCorrect="off"
              spellCheck={false}
              placeholder="Search"
              className="side_search"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={SearchImg} alt="search" width="20px" />
                  </InputAdornment>
                ),
                style: {
                  borderRadius: "0px",
                  height: "45px",
                },
              }}
            />
            <Button
              className="side_filter"
              disableRipple
              onClick={() => {
                dispatch(listDistributorMasterStart(null));
              }}
            >
              <FontAwesomeIcon
                style={{
                  fontSize: "22px",
                  color: "var(--white-color)",
                }}
                icon={["fas", "arrows-rotate"]}
              />
            </Button>

            <Button
              className="side_filter"
              disableRipple
              onClick={() => {
                setOpen(true);
              }}
            >
              <FontAwesomeIcon
                style={{
                  fontSize: "22px",
                  color: "var(--white-color)",
                }}
                icon={["fas", "add"]}
              />
            </Button>
          </div>

          <div className="side_content_container">
            {ListDistributor &&
              ListDistributor.filter((item) => {
                return Object.values(item)
                  .join("")
                  .toLowerCase()
                  .includes(search.toLowerCase());
              }).map((val, key) => (
                <div
                  key={key + 1}
                  className={`side_content_card`}
                  onClick={() => {
                    val.id && setSearchParams({ id: val.id?.toString() });
                  }}
                >
                  <div
                    className={`side_content_mini_card ${
                      val.id === distributor.id ? "active" : ""
                    }`}
                  >
                    <div className="f4 title">{val.name}</div>
                    <div className="side_content_footer side_content_footer2">
                      <h4 className="f4 subtitle">{val.code}</h4>
                      <h4
                        className={`f5 side_status ${statusClassName(
                          val.active!
                        )}`}
                      >
                        {val.active ? "Active" : "InActive"}
                      </h4>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div
          className={`mini_content_container`}
          style={{
            display: isMobile && !distributor.id ? "none" : "initial",
          }}
        >
          {Object.keys(distributor).length === 0 && (
            <div className="not_found_container">
              <img src={DataNotFound} alt="" />
              Please Select Any One Distributor
            </div>
          )}
          <DistributorMasterList
            status={Object.keys(distributor).length === 0}
            distributor={distributor}
            open={open}
            setOpen={setOpen}
          />
        </div>
      </div>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={!!listDistributorLoading}
      >
        <img
          style={{
            height: "150px",
          }}
          src={require("../../assets/images/3.gif")}
        ></img>
      </Backdrop>
    </div>
  );
};

export default DistributorMaster;
